'use strict';

var toggleInvisible = false; // Flag to alternate invisible character

/**
 * Update Gift Message Counter
 * @param {string} selector selector
 * @param {Event} event - the event object
 */
function updateCounter(selector, event) {
    if ($(selector).length > 0) {
        var textSelector = $(selector).parent().find('.remaining-characters-text');
        var currentMessageLength = $(selector).val().length;
        var remainingCharacters = 200 - currentMessageLength;
        var wasAtLimit = $('#giftMessage').hasClass('full');
        var labelText = 'characters remaining';
        var fullText;

        // Update the full text including count and label
        fullText = remainingCharacters + ' ' + labelText;
        textSelector.text(fullText);

        if (remainingCharacters === 0) {
            $('#giftMessage').addClass('full');
            // If user tries to type when at limit, force screen reader announcement
            if (event && wasAtLimit && currentMessageLength >= 200) {
                // Toggle invisible character to force aria-live to detect change
                toggleInvisible = !toggleInvisible;
                textSelector.text(fullText + (toggleInvisible ? '\u200B' : ''));
            }
        } else if (remainingCharacters > 0 && wasAtLimit) {
            $('#giftMessage').removeClass('full');
            toggleInvisible = false; // Reset toggle when leaving limit
            // Remove invisible character when leaving limit
            textSelector.text(fullText);
        }
    }
}

module.exports = {
    /**
     * Handles adjusting character count as user types gift message
     */
    initCharacterCounter: function () {
        var selector = null;
        if ($('#giftMessage').length > 0) {
            selector = '#giftMessage';
        } else if ($('#quickview-giftMessage').length > 0) {
            selector = '#quickview-giftMessage';
        }

        updateCounter(selector);


        $('body').on('input', '#giftMessage, #quickview-giftMessage', function (e) {
            updateCounter(this, e);
        });

        $('body').on('keydown', '#giftMessage, #quickview-giftMessage', function (e) {
            var currentLength = $(this).val().length;
            var isAtLimit = currentLength >= 200;
            var isCharacterKey = e.key && e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey;

            // If at limit and user tries to type a character, trigger announcement
            if (isAtLimit && isCharacterKey) {
                updateCounter(this, e);
            }
        });
    },

    updateCounter: updateCounter

};
